import React from "react"

import {
  DropdownMenuCheckboxItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from "@coval/ui"
import { Columns3 } from "lucide-react"

import type { DashboardWidget } from "../../types/core"
import {
  getRequestedWidgetWidth,
  getWidgetWidthOptions,
} from "../../utils/dashboardWidgetSizing"

interface WidgetWidthMenuProps {
  widget: DashboardWidget
  onWidthChange: (widgetId: string, columns: number) => void
}

/**
 * Width is the only size a user picks; heights follow the widget type. A
 * widget renders wider than the width chosen here when its row would
 * otherwise be left with empty columns.
 */
export const WidgetWidthMenu: React.FC<WidgetWidthMenuProps> = ({
  widget,
  onWidthChange,
}) => {
  const options = getWidgetWidthOptions(widget)
  const requestedWidth = getRequestedWidgetWidth(widget)

  if (options.length < 2) {
    return null
  }

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger
        data-testid={`dashboard-widget-${widget.id}-width`}
      >
        <Columns3 className="w-4 h-4 mr-2 shrink-0" />
        Width
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent>
        {options.map((option) => (
          <DropdownMenuCheckboxItem
            key={option.key}
            checked={option.columns === requestedWidth}
            data-testid={`dashboard-widget-${widget.id}-width-${option.key}`}
            onSelect={() => onWidthChange(widget.id, option.columns)}
          >
            {option.label}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  )
}
